import { observable } from 'aurelia-framework';

export class ComponentContext<TState extends object> {
  @observable private state: TState;
  private subscriptions = new Map<symbol, (state: TState) => void>();

  constructor(initialState: TState) {
    this.state = initialState;
  }

  getState(): TState {
    return structuredClone(this.state);
  }

  setState(updater: Partial<TState> | ((prev: TState) => Partial<TState>)) {
    const update = typeof updater === 'function' ? updater(this.state) : updater;
    Object.assign(this.state, update);
    this.notifySubscribers();
  }

  subscribe(callback: (state: TState) => void): () => void {
    const id = Symbol();
    this.subscriptions.set(id, callback);
    callback(this.state);
    return () => this.subscriptions.delete(id);
  }

  private notifySubscribers() {
    this.subscriptions.forEach((cb) => cb(this.state));
  }

  destroy() {
    this.subscriptions.clear();
  }
}
